import React from 'react';
import "./AdBlock.scss";

const AdBlock = ({ children }) => {
    return (
        <div className="ad-block">
            {children}
        </div>
    )
}

export default AdBlock;
